import Service from "../../Service";
const resource = "HmnUtilities/";

export default {

    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },

    changeState(data, requestID) {
        return Service.post(resource + "ChangeState", data, {
            params: { requestID: requestID },
        });
    }

};